import { Button, PrivateLayout } from '@components';
import { withoutAuth } from '@hocs/without-auth';
import { withoutAuthSS } from '@hocs/without-auth-ss';
import { useWeb3Auth } from '@hooks';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { ReactNode } from 'react';
import styles from '../styles/member-login.module.scss';

const MemberLoginPage = () => {
  const { t } = useTranslation('common');
  const { login } = useWeb3Auth();
  return (
    <>
      <Head>
        <title>Member Login</title>
        <meta name="description" content="Member Login" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.title}>
            <h1>{t('member_login_page.title')}</h1>
          </div>
          <div className={styles.subtitle}>
            <h2>{t('member_login_page.subtitle')}</h2>
          </div>
          <div className={styles.options_container}>
            <div className={styles.option_item}>
              <div className={styles.option_title}>{t('member_login_page.option_1.title')}</div>
              <div className={styles.option_description}>
                {t('member_login_page.option_1.description')}
              </div>
              <div className={styles.option_description_bold}>
                {t('member_login_page.option_1.aux')}
              </div>
            </div>
            <div className={styles.or}>{t('member_login_page.or')}</div>
            <div className={styles.option_item}>
              <div className={styles.option_title}>{t('member_login_page.option_2.title')}</div>
              <div className={styles.option_description}>
                {t('member_login_page.option_2.description')}
              </div>
            </div>
          </div>
          <div>
            <Button variant="privateSecondary" onClick={login}>
              {t('member_login_page.cta')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

MemberLoginPage.getLayout = (page: ReactNode) => <PrivateLayout>{page}</PrivateLayout>;

export default withoutAuth(MemberLoginPage);

export const getServerSideProps = withoutAuthSS(async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale!, ['common'])),
  },
}));
